import { useEffect, useState } from "react";
import { geoEquirectangular, geoPath } from "d3-geo";
import { feature } from "topojson-client";
import land110 from "world-atlas/land-110m.json";
import { api } from "@/lib/api";

const W = 1600;
const H = 800;
const projection = geoEquirectangular().scale(W / (2 * Math.PI)).translate([W / 2, H / 2]);
const LAND = geoPath(projection)(feature(land110, land110.objects.land));

function Spots({ cities }) {
  return cities.map((c, i) => {
    const [x, y] = projection([c.lon, c.lat]);
    const hot = c.count > 0;
    return (
      <g key={c.key} transform={`translate(${x},${y})`}>
        <circle r={hot ? 14 : 9} fill="url(#hs-glow)" className="hotspot-pulse" style={{ animationDelay: `${(i % 12) * 0.35}s` }} />
        <circle r={hot ? 3.2 : 2.2} fill={hot ? "#8E2BC4" : "#E0218A"} />
      </g>
    );
  });
}

function MapTile({ cities, offset }) {
  return (
    <g transform={`translate(${offset},0)`}>
      <path d={LAND} fill="#F6DCEB" stroke="rgba(142,43,196,0.25)" strokeWidth="0.8" />
      <Spots cities={cities} />
    </g>
  );
}

export const HeroWorldMap = () => {
  const [cities, setCities] = useState([]);
  useEffect(() => {
    api.get("/map").then((r) => setCities(Array.isArray(r.data) ? r.data.filter((c) => Number.isFinite(c?.lat) && Number.isFinite(c?.lon)) : [])).catch(() => {});
  }, []);
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true" data-testid="hero-world-map">
      <svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="xMidYMid slice" className="absolute inset-0 h-full w-full opacity-90">
        <defs>
          <radialGradient id="hs-glow"><stop offset="0%" stopColor="#FF8A3D" stopOpacity="0.75" /><stop offset="100%" stopColor="#E0218A" stopOpacity="0" /></radialGradient>
        </defs>
        <g className="hero-map-pan">
          <MapTile cities={cities} offset={0} />
          <MapTile cities={cities} offset={W} />
        </g>
      </svg>
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_10%,#FFF7FB_85%)]" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#FFF7FB]/90 via-[#FFF7FB]/40 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[#FFF7FB] to-transparent" />
    </div>
  );
};
